/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPanelLeft: {
  name: 'panel-left';
  data: string;
} = {
  name: 'panel-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 .5A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h12a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 14 .5H2Zm2.5 1H2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h2.5v-13Zm1 13v-13H14a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H5.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
